import React from 'react';
import MapSkeletonLoader from './MapSkeletonLoader';

export default {
  title: 'Components/LoadingSkeletons/MapSkeletonLoader',
  component: MapSkeletonLoader,
  parameters: {
    layout: 'left',
  },
  tags: ['autodocs'],
  argTypes: {
    shouldEnableAnimation: {
      control: { type: 'boolean' },
      description: 'Controls the shouldEnableAnimation prop. By default, it is set to false to keep animations disabled. Set this value to true to enable animations.',
      table: {
        type: { summary: 'Boolean' },
        defaultValue: { summary: false },
      },
    },
    width: {
      control: { type: 'text' },
      description: 'Sets the width of the map skeleton container.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '100%' },
      },
    },
    height: {
      control: { type: 'text' },
      description: 'Sets the height of the map skeleton container.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '800px' },
      },
    },
    iconSize: {
      control: { type: 'number' },
      description: 'Specifies the size of the centered icon placeholder.',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 40 },
      },
    },
    backgroundColor: {
      control: { type: 'color' },
      description: 'Sets the background color of the centered icon placeholder.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: '#E4E4E4' },
      },
    },
    controlWidth: {
      control: { type: 'number' },
      description: 'Width of the top-left map control skeletons (e.g., Map/Satellite toggle).',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 60 },
      },
    },
    controlHeight: {
      control: { type: 'number' },
      description: 'Height of the top-left map control skeletons (e.g., Map/Satellite toggle).',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 30 },
      },
    },
    screenModeWidth: {
      control: { type: 'number' },
      description: 'Width of the top-right screen mode toggle skeleton (e.g., full-screen button).',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 40 },
      },
    },
    screenModeHeight: {
      control: { type: 'number' },
      description: 'Height of the top-right screen mode toggle skeleton (e.g., full-screen button).',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 40 },
      },
    },
    zoomControlSize: {
      control: { type: 'number' },
      description: 'Size of the bottom-right zoom control skeletons (zoom-in and zoom-out).',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 40 },
      },
    },
  },
};

// Default Template
const Template = (args) => <MapSkeletonLoader {...args} />;

export const Default = Template.bind({});
Default.args = {
  width: '100%',
  height: '800px',
  iconSize: 40,
  backgroundColor: '#E4E4E4',
  controlWidth: 60,
  controlHeight: 30,
  screenModeWidth: 40,
  screenModeHeight: 40,
  zoomControlSize: 40,
};

export const SmallLoader = Template.bind({});
SmallLoader.args = {
  width: '100%',
  height: '400px',
  iconSize: 30,
  backgroundColor: '#CCCCCC',
  controlWidth: 50,
  controlHeight: 25,
  screenModeWidth: 30,
  screenModeHeight: 30,
  zoomControlSize: 30,
};

export const LargeLoader = Template.bind({});
LargeLoader.args = {
  width: '100%',
  height: '1000px',
  iconSize: 50,
  backgroundColor: '#BBBBBB',
  controlWidth: 70,
  controlHeight: 35,
  screenModeWidth: 50,
  screenModeHeight: 50,
  zoomControlSize: 50,
};

export const CustomColorLoader = Template.bind({});
CustomColorLoader.args = {
  width: '100%',
  height: '800px',
  iconSize: 40,
  backgroundColor: '#4CAF50', // Green background color
  controlWidth: 60,
  controlHeight: 30,
  screenModeWidth: 40,
  screenModeHeight: 40,
  zoomControlSize: 40,
};
